import axios from './config.js'

export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js